export enum Entity {
  PARTNER = 1,
  RESELLER = 2,
  MERCHANT = 3,
  BRANCH = 4,
}

export enum BillingCycle {
  WEEKLY = 1,
  BI_WEEKLY = 2,
  MONTHLY = 3,
  QUARTERLY = 4,
  ANNUALLY = 5,
}
